// extracted by mini-css-extract-plugin
export var date = "BlogThumbnail-module--date--YhdTG";
export var img = "BlogThumbnail-module--img--U4NYr";
export var imgLink = "BlogThumbnail-module--img-link--Vhr5o";
export var reading_time = "BlogThumbnail-module--reading_time--I+8Cu";
export var section = "BlogThumbnail-module--section--qhDPZ";
export var section_title = "BlogThumbnail-module--section_title--TIPRJ";
export var separator = "BlogThumbnail-module--separator--hrhE2";
export var thumbnail_container = "BlogThumbnail-module--thumbnail_container--sV8vJ";
export var title = "BlogThumbnail-module--title--T3u0a";